import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

import { OnlyDigitsPipe } from '@app/pipes/input-pipes/only-digits.pipe';

@Directive({
  selector: '[appOnlyDigits]',
  standalone: false
})
export class OnlyDigitsDirective {

  constructor(
    private onlyDigitsPipe: OnlyDigitsPipe,
    private _el: ElementRef,
    private _render: Renderer2) { }

  @HostListener('keyup', ['$event']) public onKeyUp(e: Event): void {
    const initialValue = this._el.nativeElement.value;
    const finalValue = this.onlyDigitsPipe.transform(initialValue);
    const pos = this._el.nativeElement.selectionStart;
    this._render.setProperty(this._el.nativeElement, 'value', finalValue);
    if (initialValue !== this._el.nativeElement.value) e.preventDefault();
    setTimeout(() => {
      this._el.nativeElement.focus();
      if (initialValue === this._el.nativeElement.value) {
        this._el.nativeElement.setSelectionRange(pos, pos);
      }
    });
  }

}
